import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { LiquidGlassNav } from "@/ui";
import { Topbar } from "@/app/Topbar";
import { HomeScreen } from "@/screens/home/HomeScreen";
import { TodayScreen } from "@/screens/today/TodayScreen";
import { SignalsScreen } from "@/screens/signals/SignalsScreen";
import { MakeScreen } from "@/screens/make/MakeScreen";
import { DesignsScreen } from "@/screens/designs/DesignsScreen";
import { LayoutsScreen } from "@/screens/layouts/LayoutsScreen";
import { LibraryScreen } from "@/screens/library/LibraryScreen";
import { YouScreen } from "@/screens/you/YouScreen";
import { SdkScreen } from "@/screens/sdk/SdkScreen";
import { Login } from "@/screens/auth/Login";
import { Register } from "@/screens/auth/Register";
import { Callback } from "@/auth/Callback";
import { ProtectedRoute } from "@/auth/ProtectedRoute";
import { PresentScreen } from "@/screens/present/PresentScreen";

/** App chrome: Topbar + scrolling content + the floating liquid-glass nav. */
function Shell() {
  return (
    <div className="relative min-h-screen">
      <Topbar />
      <main className="relative z-10 mx-auto max-w-5xl px-4 pb-44 pt-5 md:px-6 md:pb-48 md:pt-7">
        <Outlet />
      </main>
      <LiquidGlassNav />
    </div>
  );
}

export function App() {
  return (
    <Routes>
      {/* bare surfaces — no chrome */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/callback" element={<Callback />} />
      <Route path="/present" element={<PresentScreen />} />

      {/* the studio — gated behind a real OIDC session (see ProtectedRoute) */}
      <Route
        element={
          <ProtectedRoute>
            <Shell />
          </ProtectedRoute>
        }
      >
        <Route path="/home" element={<HomeScreen />} />
        <Route path="/today" element={<TodayScreen />} />
        <Route path="/signals" element={<SignalsScreen />} />
        <Route path="/signals/:panel" element={<SignalsScreen />} />
        <Route path="/make" element={<MakeScreen />} />
        <Route path="/designs" element={<DesignsScreen />} />
        <Route path="/layouts" element={<LayoutsScreen />} />
        <Route path="/library" element={<LibraryScreen />} />
        <Route path="/sdk" element={<SdkScreen />} />
        <Route path="/you" element={<YouScreen />} />
        <Route path="/you/:section" element={<YouScreen />} />
      </Route>

      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
}
